
import React, { useState } from 'react';
import { DialogHeader, DialogFooter } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { ConsentPreferences, getConsentPreferences, saveConsentPreferences } from '@/utils/cookieConsent';

interface CookieSettingsProps {
  onClose: () => void;
}

const CookieSettings: React.FC<CookieSettingsProps> = ({ onClose }) => {
  const [preferences, setPreferences] = useState<ConsentPreferences>(getConsentPreferences());

  const handleToggle = (type: keyof ConsentPreferences) => {
    if (type === 'necessary') return; // Cannot toggle necessary cookies
    
    setPreferences(prev => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  const handleSave = () => {
    saveConsentPreferences(preferences);
    onClose();
  };

  return (
    <>
      <DialogHeader className="text-left">
        <h2 className="text-xl font-semibold">Cookie Preferences</h2>
        <p className="text-sm text-muted-foreground">
          Customize your cookie preferences. Some cookies are necessary for the website to function 
          and cannot be disabled.
        </p>
      </DialogHeader>

      <div className="py-4 space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-medium">Necessary Cookies</h3>
            <p className="text-sm text-muted-foreground">
              Essential for the website to function properly. Cannot be disabled.
            </p>
          </div>
          <Switch checked={true} disabled />
        </div>

        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-medium">Analytics Cookies</h3>
            <p className="text-sm text-muted-foreground">
              Help us understand how visitors interact with our website.
            </p>
          </div>
          <Switch 
            checked={preferences.analytics} 
            onCheckedChange={() => handleToggle('analytics')} 
          />
        </div>

        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-medium">Marketing Cookies</h3>
            <p className="text-sm text-muted-foreground">
              Used to track visitors across websites to display relevant advertisements.
            </p>
          </div>
          <Switch 
            checked={preferences.marketing} 
            onCheckedChange={() => handleToggle('marketing')} 
          />
        </div>
      </div>

      <DialogFooter>
        <Button variant="outline" onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave}>Save Preferences</Button>
      </DialogFooter>
    </>
  );
};

export default CookieSettings;
